import React from 'react';
import { Icon } from '@unite-us/app-components';
import { PropTypes } from 'prop-types';
import cx from 'classnames';

const CardHeader = ({
  borderColor,
  iconColor,
  title,
  subtitle,
  titleIcon,
  className,
  titleClassName,
}) => (
  <div className={className}>
    <div className="flex items-center pt-1">
      {
        titleIcon && (
          <Icon
            className="h-18 ml-3 -mr-2"
            color={iconColor}
            icon={titleIcon}
          />
        )
      }
      <div className={cx('pl-4', titleClassName)}>
        {title}
      </div>
    </div>
    { subtitle &&
      (<div className="pt-1 pl-4 text-text-blue text-sm">{subtitle}</div>)}
    <hr className={cx('pt-2 -mx-4', borderColor)} />
  </div>
);

CardHeader.propTypes = {
  borderColor: PropTypes.string,
  iconColor: PropTypes.string,
  titleIcon: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.node,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
};

CardHeader.defaultProps = {
  borderColor: 'border-dark-border-blue',
  iconColor: '#CF2B29',
  titleIcon: null,
  className: '',
  subtitle: null,
  titleClassName: 'text-text-blue text-base font-extrabold',
};

export default CardHeader;
